import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";

type BugsnagShape = {
  notify: (error: Error, options?: { severity: string }) => void;
  getPlugin: (name: string) => any;
};

const NullBugnag: BugsnagShape = {
  notify: () => {},
  getPlugin: () => null,
};

const BugsnagInstance: BugsnagShape = (() => {
  if (!process.env.NEXT_PUBLIC_BUGSNAG_API_KEY) {
    console.info("Bugsnag API key is not set. Bugsnag will not be used.");
    return NullBugnag;
  }

  Bugsnag.start({
    apiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY || "",
    plugins: [new BugsnagPluginReact()],
    onError: (event) => {
      // Discard non-harmful events
      const filter = [
        "ResizeObserver loop limit exceeded",
        "ResizeObserver loop completed with undelivered notifications.",
        "Illegal invocation",
      ];
      if (filter.some((f) => event?.errors?.[0]?.errorMessage?.includes(f))) {
        return false;
      }
      return true;
    },
  });

  return Bugsnag as BugsnagShape;
})();

export default BugsnagInstance;
